var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSaber = function SvgIconSaber(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 4.233 4.233",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m.437 2.796.28.287-.55.604.252.307.598-.568.306.339s.348-.405.087-.715C1.702 2.763 3.872.7 3.872.7l.194-.46-.453.144-2.483 2.33s-.324-.256-.693.081z"
  })));
};
export default SvgIconSaber;